
<div class="delete-modal">
  <mat-dialog-content class="mat-typography text-center">
    <h2 mat-dialog-title class="text-center">Saved Succsesfully</h2>
    <mat-icon class="danger-icon" aria-hidden="false"></mat-icon>
    <!--<h2 mat-dialog-title class="text-center">
      Delete
      <span class="font-weight-bold text-uppercase">{{ local_data.name }}</span>
      ?
    </h2> -->
  </mat-dialog-content>
  <mat-dialog-actions align="center">

    <button mat-raised-button class="btn btn-success" mat-dialog-close>
      Done
    </button>
  </mat-dialog-actions>
</div>
